<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="SupplierRateTable1" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :hb_table_class="'hb_table_supplierRate_class1'" :query_button_label="query_lable" @on_query="on_query"
        @state_change="state_change" :show_toolbar_button="[0, 0, 0, 0, 0]" @tool_invoke="tool_invoke"
        @current_changed="current_changed" @on_cell_button_click="on_cell_button_click" @on_change="on_change">
        <template #query>
          {{ $t("common.provider") + $t("common.num") }}：<el-input clearable size="small" style="width: 100px"
            v-model="AccountNum"></el-input>
          {{ $t("common.provider") + $t("common.num") }}：<el-input clearable size="small" style="width: 120px"
            v-model="supplier_name"></el-input>
        </template>
        <!-- <template #toolbar="">
          <el-button
            type="info"
            plain
            @click="createForm('new')"
            style="width: 55px"
            class="ml-2 iconfont icon-add-new"
            size="mini"
          ></el-button>
        </template> -->
        <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="SaveData"
            :label="$t('common.save')" class="ml-2">
          </QueryButton>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
import QueryButton from "../components/base/QueryButton"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
import TestQueryPanel from "../components/base/TestQueryPanel"
import * as api from "../../shared/api"
import * as SupplierRateController from "../../controllers/mm/SupplierRateController"

export default {
  name: "SupplierRate",
  components: {
    QueryButton,
    BaseContainer,
    TableMain,
    TestQueryPanel,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_supplier_rate",
      },
      fields: SupplierRateController.fields.default,
      dataForm: _.cloneDeep(SupplierRateController.dataForm),
      rules: SupplierRateController.rules,
      changedList: [],
      isBusy_table1: false,
      AccountNum: "",
      supplier_name: "",
    }
  },
  created() { },
  methods: {
    //#region 查询
    async on_query(set_data, date_range) {
      ///模拟数据
      this.isBusy_table1 = true
      if (
        _.isNull(date_range) &&
        this.AccountNum == "" &&
        this.supplier_name == ""
      ) {
        this.msgModal(this.$t("notify.wait_too_long")).then(
          async (value) => {
            if (value) {
              await this.excuteQuery(set_data, date_range)
            }
          }
        )
      } else {
        await this.excuteQuery(set_data, date_range)
      }
    },
    async excuteQuery(set_data, date_range) {
      let _fromDate = "",
        _toDate = ""
      let _params = {
        SEI_Name: { like: "%" + this.supplier_name + "%" },
      }
      if (this.AccountNum != "") {
        _params.AccountNum = { like: "%" + this.AccountNum + "%" }
      }
      if (
        !_.isNull(date_range) &&
        this.AccountNum == "" &&
        this.supplier_name == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        _params["modifiedDateTime"] = { ">=": _fromDate, "<=": _toDate }
      }

      this.changedList = []
      set_data([])

      let _result = await SupplierRateController.methods.getData(_params)

      if (!_.isNull(_result) && _result && _result.length > 0) {
        if (
          _result[0].Result &&
          _result[0].Result.Data &&
          _result[0].Result.Data.length > 0
        ) {
          _.each(_result[0].Result.Data[0], (t) => {
            let _m = _.find(_result[1].Result.Data[0], {
              VendAccountNum: t.AccountNum,
            })
            if (_m) {
              t.vend_rate_id = _m.id
              t.TotalScore = _m.TotalScore / 20
              t.QualityScore = _m.QualityScore / 5
              t.ServiceScore = _m.ServiceScore / 5
              t.DeliveryScore = _m.DeliveryScore / 5
              t.ResponseScore = _m.ResponseScore / 5
            } else {
              t.vend_rate_id = ""
              t.TotalScore = 0
              t.QualityScore = 0
              t.ServiceScore = 0
              t.DeliveryScore = 0
              t.ResponseScore = 0
            }
          })
          set_data(_.orderBy(_result[0].Result.Data[0], ["id"], ["asc"]))
          this.changedList = _result[0].Result.Data[0]
        }
      }
      this.isBusy_table1 = false
    },
    //#endregion

    //#region 保存
    async SaveData(cb) {
      console.log(this.changedList)
      if (this.changedList && this.changedList.length > 0) {
        let _items = []
        _.each(this.changedList, (t) => {
          _items.push({
            id: t.vend_rate_id,
            TotalScore: t.TotalScore,
            ServiceScore: t.ServiceScore,
            QualityScore: t.QualityScore,
            ResponseScore: t.ResponseScore,
            DeliveryScore: t.DeliveryScore,
            VendAccountNum: t.AccountNum,
          })
        })
        let _result = await SupplierRateController.methods.saveData(_items)

        if (!_.isNull(_result) && _result.length == _items.length) {
          this.changedList = []
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          let _list = _.filter(_result, function (t) {
            return t.Code.indexOf("data/i/") > -1
          })
          if (_list && _list.length > 0) {
            _.each(_list, (t) => {
              let _m = _.find(this.$refs.SupplierRateTable1.my_data, {
                AccountNum: t.Result.Data[0][0].VendAccountNum,
              })
              if (_m) {
                _m.vend_rate_id = t.Result.Data[0][0].id
                _m.TotalScore = t.Result.Data[0][0].TotalScore
                _m.ServiceScore = t.Result.Data[0][0].ServiceScore
                _m.QualityScore = t.Result.Data[0][0].QualityScore
                _m.ResponseScore = t.Result.Data[0][0].ResponseScore
                _m.DeliveryScore = t.Result.Data[0][0].DeliveryScore
              }
              this.$refs.SupplierRateTable1.UpdateItems(
                { AccountNum: t.Result.Data[0][0].VendAccountNum },
                _m
              )
            })
          }
        } else {
          this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        }
      }
      cb(true)
    },
    //#endregion

    on_change(data) {
      data.item.TotalScore =
        (data.item.ServiceScore +
          data.item.DeliveryScore +
          data.item.ResponseScore +
          data.item.QualityScore) /
        4
    },

    //#region 状态切换
    // state_change(data, cb) {

    // },
    //#endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: this.$t("table.table_customer"),
          sheet_title: this.$t("table.table_customer"),
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    //#endregion

    ///cell点击
    on_cell_button_click(data) {

    },

    current_changed(old, current) {

    },
  },
}
</script>
<style>
.hb_table_supplierRate_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 120rem;
}
</style>
